import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getConsent, CONSENT_EVENT } from "@/components/CookieBanner";

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

let loaded = false;

function loadGtag(id) {
  if (loaded || typeof window === "undefined") return;
  loaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", id, { send_page_view: false, anonymize_ip: true });
}

export default function Analytics() {
  const location = useLocation();
  const [consent, setConsentState] = useState(getConsent());

  // React to consent changes emitted by the CookieBanner
  useEffect(() => {
    const onChange = (e) => setConsentState(e?.detail || getConsent());
    window.addEventListener(CONSENT_EVENT, onChange);
    return () => window.removeEventListener(CONSENT_EVENT, onChange);
  }, []);

  useEffect(() => {
    if (!GA_ID) return;
    if (consent === "all") loadGtag(GA_ID);
  }, [consent]);

  useEffect(() => {
    if (!GA_ID || !window.gtag || consent !== "all") return;
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location, consent]);

  return null;
}

export function trackEvent(name, params = {}) {
  if (typeof window === "undefined" || !window.gtag) return;
  window.gtag("event", name, params);
}
